var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoArrowMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70998 7.70998C8.31998 7.31998 8.31998 6.68998 8.70998 6.29998L11.3 3.70998C11.69 3.31998 12.32 3.31998 12.71 3.70998L15.3 6.29998C15.69 6.68998 15.69 7.31998 15.3 7.70998C14.91 8.09998 14.28 8.09998 13.89 7.70998L13 6.82998V11.93C13 12.99 13.42 14.01 14.17 14.76L18.29 18.88C18.68 19.27 18.68 19.9 18.29 20.29C17.9 20.68 17.27 20.68 16.88 20.29L12 15.41L7.11998 20.29C6.72998 20.68 6.09998 20.68 5.70998 20.29C5.31998 19.9 5.31998 19.27 5.70998 18.88L9.82998 14.76C10.58 14.01 11 12.99 11 11.93V6.82998L10.12 7.70998C9.72998 8.09998 9.09998 8.09998 8.70998 7.70998Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowMerge);
export default __webpack_public_path__ + "static/media/ico-arrow-merge.56b0885938f1ddc99fc4986707de6f4e.svg";
export { ForwardRef as ReactComponent };